import AboutMe from "../AboutMe/AboutMe";
import style from "../../App.module.css";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import Main from "../Main/Main";
import MyWorks from "../MyWorks/MyWorks";

function Partfolio() {
  return (
    <div className={style.wrapper}>
      <div className={style.container}>
        <Header/>
        <Main />
        <AboutMe />
        <MyWorks />
        <Footer/>
      </div>
    </div>
  );
}

export default Partfolio;
 